import { render, staticRenderFns } from "./UIToolBar.vue?vue&type=template&id=37123dac"
import script from "./UIToolBar.vue?vue&type=script&lang=ts"
export * from "./UIToolBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports